var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitterSection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#1DA1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 13.0082C29 13.0082 27.3489 13.9835 26.4309 14.26C25.9382 13.6935 25.2833 13.2919 24.5548 13.1096C23.8264 12.9274 23.0596 12.9732 22.3581 13.241C21.6565 13.5087 21.0542 13.9855 20.6324 14.6067C20.2107 15.228 19.9899 15.9638 20 16.7146V17.5328C18.5622 17.5701 17.1374 17.2512 15.8526 16.6045C14.5679 15.9578 13.463 15.0035 12.6364 13.8264C12.6364 13.8264 9.36364 21.19 16.7273 24.4628C15.0422 25.6066 13.0349 26.1801 11 26.0991C18.3636 30.19 27.3636 26.0991 27.3636 16.69C27.3636 16.4626 27.3407 16.2351 27.2982 16.011C28.1327 15.1879 29 13.0082 29 13.0082Z",
    stroke: "#1DA1F2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterSection);
export default __webpack_public_path__ + "static/media/Twitter_Section.67969064cacc43221d3f9d11334cbe7b.svg";
export { ForwardRef as ReactComponent };